<div id="uxMessageLabel" *ngIf="haserror">
    <div class="row">
        <div class="col-24">
            <p class="bottom-20"><strong>Note:</strong> Your access to Electronic SOA is temporarily denied for the following reason(s):</p>
            <!--<p *ngIf="trainingMsg" class="bottom-10">You have not completed the {{planYear}} certification training course. To access Electronic SOA, you must first complete the <a class="link" (click)="GetTrainingURL()" class="link-button" target='_blank'>Online Training  </a>.</p>-->
            <p *ngIf="trainingMsg" class="bottom-10">
                You have not completed the necessary certification training course.<br />
                For additional information on training, please visit the <a (click)="GetTrainingURL()">Training and Certification</a> page.
            </p>
            <p *ngIf="backgroundMsg" class="bottom-10">Please note that you will not be be able to access this page further until {{insuranceCompanyShortName}} completes processing your background check.</p>
            <p *ngIf="trainingFailedMsg" class="bottom-20">You have failed the {{planYear}} certification training course.</p>
            <p *ngIf="licencemsg" class="bottom-20">You do not have a valid state license.</p>
        </div>
    </div>
</div>
<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="keyDownFunction($event)" *ngIf="validAgent">
    <div *ngIf="!DynamicPlanYear; then CurrentPlanYear else NewPlanYear"></div>
    <ng-template #CurrentPlanYear>
        <div class="row">
            <div class="col-16">
                <div class="both-at-end">
                    <h1 class="long-heading">Scope of Sales Appointment Confirmation </h1>
                    <button class="button primary" (click)="ViewSOAHistory()">SOA History</button>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p>The Centers for Medicare and Medicaid Services requires agents to document the scope of a marketing appointment prior to any sales meeting to ensure understanding of what will be discussed between the agent and the Medicare beneficiary (or their authorized representative). All information provided on this form is confidential and should be completed by each person with Medicare or his/her authorized representative.</p>
            </div>
        </div>

        <div class="row">
            <div class="col-16">
                <p><strong>Please initial below beside the type of product(s) you want the agent to discuss.</strong></p>
            </div>
            <div class="col-16">
                <div class="bottom-20 centered-label">
                    <input type="text" id="standAlonePlan" name="standAlonePlan" disabled="disabled">
                    <label for="standAlonePlan">Stand-alone Medicare Prescription Drug Plans (Part D)</label>
                </div>
            </div>
            <div class="col-16">
                <p><strong>Medicare Prescription Drug Plan (PDP) -</strong> A stand-alone drug plan that adds prescription drug coverage to Original Medicare, some Medicare Cost Plans, some Medicare Private-Feefor- Service Plans, and Medicare Medical Savings Account Plans.</p>
            </div>
            <div class="col-16">
                <div class="bottom-20 centered-label">
                    <input type="text" id="advantagePlan" name="advantagePlan" disabled="disabled">
                    <label for="advantagePlan">Medicare Advantage Plans (Part C) and Cost Plans</label>
                </div>
            </div>
            <div class="col-16">
                <p><strong>Medicare Health Maintenance Organization (HMO) -</strong> A Medicare Advantage Plan that provides all Original Medicare Part A and Part B health coverage and sometimes covers Part D prescription drug coverage. In most HMOs, you can only get your care from doctors or hospitals in the plan's network (except in emergencies).</p>
            </div>
            <div class="col-16">
                <p><strong>Medicare Preferred Provider Organization (PPO) Plan -</strong> A Medicare Advantage Plan that provides all Original Medicare Part A and Part B health coverage and sometimes covers Part D prescription drug coverage. PPOs have network doctors and hospitals but you can also use outof- network providers, usually at a higher cost.</p>
            </div>
            <div class="col-16">
                <p><strong>Medicare Private Fee-For-Service (PFFS) Plan -</strong> A Medicare Advantage Plan in which you may go to any Medicare-approved doctor, hospital and provider that accepts the plan's payment, terms and conditions and agrees to treat you - not all providers will. If you join a PFFS Plan that has a network, you can see any of the network providers who have agreed to always treat plan members. You will usually pay more to see out-of-network providers.</p>
            </div>
            <div class="col-16">
                <p><strong>Medicare Special Needs Plan (SNP) -</strong> A Medicare Advantage Plan that has a benefit package designed for people with special health care needs. Examples of the specific groups served include people who have both Medicare and Medicaid, people who reside in nursing homes, and people who have certain chronic medical conditions.</p>
            </div>
            <div class="col-16">
                <p><strong>Medicare Medical Savings Account (MSA) Plan -</strong> MSA Plans combine a high deductible health plan with a bank account. The plan deposits money from Medicare into the account. You can use it to pay your medical expenses until your deductible is met.</p>
            </div>
            <div class="col-16">
                <p><strong>Medicare Cost Plan -</strong> In a Medicare Cost Plan, you can go to providers both in and out of network. If you get services outside of the plan's network, your Medicare-covered services will be paid for under Original Medicare but you will be responsible for Medicare coinsurance and deductibles.</p>
            </div>
            <div class="col-16">
                <p class="partition">
                    <strong>
                        By signing this form, you agree to a meeting with a sales agent to discuss the types
                        of products you initialed above.
                    </strong> Please note, the person who will discuss the products is either employed or contracted by a Medicare plan. They <u>do not</u> work directly for the Federal government. This individual may also be paid based on your enrollment in a plan.
                </p>
                <p>Signing this form does NOT obligate you to enroll in a plan, affect your current enrollment, or enroll you in a Medicare plan.</p>
            </div>
        </div>
        <div>
            <div class="row">
                <div class="col-16">
                    <p><strong>Beneficiary or Authorized Representative Signature and Signature Date</strong></p>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="txtSignature">Signature</label>
                        <input name="txtSignature" type="text" id="txtSignature" disabled="disabled" placeholder="Signature">
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="txtdate">Date</label>
                        <input name="txtdate" type="text" id="txtdate" disabled="disabled" placeholder="Date">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p>If you are the authorized representative, please sign below:</p>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="txtRepName">Representative's Name</label>
                        <input name="txtRepName" type="text" id="txtRepName" disabled="disabled" data-type="alphaChar" placeholder="Representative's Name">
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="txtRelationship">Your Relationship to the Beneficiary</label>
                        <input name="txtRelationship" type="text" id="txtRelationship" disabled="disabled" placeholder="Relationship to the Beneficiary">
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-16">
                    <p class="required partition">All fields are required, unless marked as optional.</p>
                </div>
            </div>
            <fieldset>
                <legend>To be completed by Agent</legend>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper" [ngClass]="{'input-error': agentNameError || specialCharacterAgentNameError}">
                            <ValidatedTextField [label]="'Agent Name'"
                                                id="agentName"
                                                [maxlength]="150"
                                                (onValueChange)="soaSubmitDetails.AgentName = $event"
                                                [text]="soaSubmitDetails.AgentName">
                            </ValidatedTextField>
                            <div class="field-error-message">{{agentNameError}}</div>
                            <div class="field-error-message">{{specialCharacterAgentNameError}}</div>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper" [ngClass]="{'input-error': agentPhoneError || agentPhoneFormatError}">
                            <!--
                                            <ValidatedTextField [label]="'Agent Phone'"
                                                id="agentPhone"
                                                [maxlength]="10"
                                                (onValueChange)="soaSubmitDetails.AgentPhone = $event"
                                                [text]="soaSubmitDetails.AgentPhone">
                            </ValidatedTextField> -->

                            <MaskedValidatedTextField [label]="'Agent Phone'"
                                                      id="agentPhone"
                                                      [maxlength]="10"
                                                      (onValueChange)="soaSubmitDetails.AgentPhone = $event"
                                                      [text]="soaSubmitDetails.AgentPhone"
                                                      [inputMask]="phoneNumberInputMask">
                            </MaskedValidatedTextField>

                            <div class="field-error-message">{{agentPhoneError}}</div>
                            <div class="field-error-message">{{agentPhoneFormatError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper" [ngClass]="{'input-error': agentAddressError}">
                            <ValidatedTextField [label]="'Agent Address'"
                                                id="agentAddress"
                                                [maxlength]="250"
                                                (onValueChange)="soaSubmitDetails.AgentAddress = $event"
                                                [text]="soaSubmitDetails.AgentAddress">

                            </ValidatedTextField>
                            <div class="field-error-message">{{agentAddressError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper" [ngClass]="{'input-error': beneficiaryNameError || specialCharacterBeneficiaryNameError}">
                            <ValidatedTextField [label]="'Beneficiary Name'"
                                                id="beneficiaryName"
                                                [maxlength]="150"
                                                (onValueChange)="soaSubmitDetails.BeneficiaryName = $event"
                                                [text]="soaSubmitDetails.BeneficiaryName">
                            </ValidatedTextField>
                            <div class="field-error-message">{{beneficiaryNameError}}</div>
                            <div class="field-error-message">{{specialCharacterBeneficiaryNameError}}</div>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper" [ngClass]="{'input-error': beneficiaryPhoneError || beneficiaryPhoneFormatError}">
                            <!--<ValidatedTextField [label]="'Beneficiary Phone'"
                                                id="beneficiaryPhone"
                                                [maxlength]="10"
                                                (onValueChange)="soaSubmitDetails.BeneficiaryPhone = $event"
                                                [text]="soaSubmitDetails.BeneficiaryPhone">
                            </ValidatedTextField>-->
                            <MaskedValidatedTextField [label]="'Beneficiary Phone'"
                                                      id="beneficiaryPhone"
                                                      [maxlength]="10"
                                                      (onValueChange)="soaSubmitDetails.BeneficiaryPhone = $event"
                                                      [text]="soaSubmitDetails.BeneficiaryPhone"
                                                      [inputMask]="phoneNumberInputMask">
                            </MaskedValidatedTextField>
                            <div class="field-error-message">{{beneficiaryPhoneError}}</div>
                            <div class="field-error-message">{{beneficiaryPhoneFormatError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper" [ngClass]="{'input-error': beneficiaryAddressError}">
                            <ValidatedTextField [label]="'Beneficiary Address'"
                                                id="beneficiaryAddress"
                                                [maxlength]="250"
                                                (onValueChange)="soaSubmitDetails.BeneficiaryAddress = $event"
                                                [text]="soaSubmitDetails.BeneficiaryAddress">
                            </ValidatedTextField>
                            <div class="field-error-message">{{beneficiaryAddressError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper" [ngClass]="{'input-error': beneficiaryMethodOfContactError || specialCharacterBeneficiaryMethodOfContactError}">
                            <ValidatedTextField [label]="'Initial Method of Contact (Indicate here if beneficiary was a walk-in.)'"
                                                id="beneficiaryMethodOfContact"
                                                [maxlength]="100"
                                                (onValueChange)="soaSubmitDetails.ContactMethod = $event"
                                                [text]="soaSubmitDetails.ContactMethod">

                            </ValidatedTextField>
                            <div class="field-error-message">{{beneficiaryMethodOfContactError}}</div>
                            <div class="field-error-message">{{specialCharacterBeneficiaryMethodOfContactError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper" [ngClass]="{'input-error': agentSignatureError || specialCharacterAgentSignatureError}">
                            <ValidatedTextField [label]="'Agent Signature'"
                                                id="agentSignatureName"
                                                [maxlength]="100"
                                                (onValueChange)="soaSubmitDetails.AgentSignatureName = $event"
                                                [text]="soaSubmitDetails.AgentSignatureName">

                            </ValidatedTextField>
                            <div class="field-error-message">{{agentSignatureError}}</div>
                            <div class="field-error-message">{{specialCharacterAgentSignatureError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20" [ngClass]="{'input-error': planError}">
                            <label for="txtPlans">Plan(s) the agent represented during this meeting</label>
                            <textarea name="txtPlans" rows="3" cols="20" maxlength="500" id="txtPlans" class="ckValidate textMultiline" placeholder="Plans" [(ngModel)]="soaSubmitDetails.Plan" required="required"></textarea>
                            <div class="field-error-message">{{planError}}</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20" [ngClass]="{'input-error': dateOfAppointmentError}">
                            <label for="dateAppointment">Date of Appointment</label>
                            <JQDatePicker [selectedDate]="soaSubmitDetails.ApplicationDate" (elementClicked)="soaSubmitDetails.ApplicationDate = $event"></JQDatePicker>

                            <!--<jqxDateTimeInput [width]="300" [height]="25"  [(ngModel)]=  "soaSubmitDetails.ApplicationDateStr"  ></jqxDateTimeInput>
                            <ng-datepicker [(ngModel)]="soaSubmitDetails.ApplicationDate" id="dateAppointment">
                            </ng-datepicker>-->
                            <div class="field-error-message">{{dateOfAppointmentError}} </div>
                        </div>
                    </div>
                </div>
            </fieldset>
            <div class="row">
                <div class="col-16">
                    <h2>Instructions for agents</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p>If you are doing a sales presentation to a beneficiary, you <strong>MUST</strong> have a documented scope of what you will be discussing with the beneficiary prior to the appointment. A beneficiary cannot agree to the scope over the phone and sign the documentation later. Documentation must be in writing in the form of a signed document by the beneficiary. You must send this documentation with the enrollment form to {{insuranceCompany}}.</p>
                    <p><small>* Scope of Appointment documentation is subject to CMS record retention requirements *</small> </p>

                    <p>If the form was signed by the beneficiary at time of appointment, provide explanation why SOA was not documented prior to meeting</p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <div class="bottom-20" [ngClass]="{'input-error': txtWhyNoDocsError}">
                        <textarea name="txtWhyNoDocs"
                                  rows="3" cols="20"
                                  id="txtWhyNoDocs"
                                  placeholder="Why SOA was not documented prior to meeting"
                                  class="textMultiline"
                                  [(ngModel)]="soaSubmitDetails.Instructions"></textarea>
                        <div class="field-error-message">  {{txtWhyNoDocsError}} </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p>{{insuranceCompanyShortName}} is a Prescription Drug Plan with a Medicare contract offered by {{insuranceCompany}}. Enrollment in {{insuranceCompanyShortName}} depends on contract renewal.</p>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #NewPlanYear>
        <div class="row">
            <div class="col-16">
                <div class="both-at-end">
                    <h1 class="long-heading">Scope of Sales Appointment Confirmation Form</h1>
                    <button class="button primary" (click)="ViewSOAHistory()">SOA History</button>

                </div>
            </div>
        </div>
        <div>
            <div class="row">
                <div class="col-16">
                    <p>This form is required prior to a one-on-one marketing appointment to ensure understanding of what will be discussed between the agent and the Medicare beneficiary (or their authorized representative). All information provided on this form is confidential and should be completed by each person with Medicare or his/her authorized representative.</p>
                </div>
            </div>

            <div class="row">
                <div class="col-16">
                    <p><strong>Please place a check mark in the box next to the of product(s) you want the agent to discuss.</strong> (See helpful descriptions on the next page.)</p>
                </div>
                <div class="col-16">
                    <div class="bottom-20 centered-label">
                        <input type="checkbox" id="standAlonePlan" name="standAlonePlan" disabled="disabled">
                        <label for="standAlonePlan">Stand-alone Medicare Prescription Drug Plans (Part D)</label>
                    </div>
                </div>
                <div class="col-16">
                    <div class="bottom-20 centered-label">
                        <input type="checkbox" id="advantagePlan" name="advantagePlan" disabled="disabled">
                        <label for="advantagePlan">Medicare Advantage Plans (Part C) and Cost Plans</label>
                    </div>
                    <p>Medicare Health Maintenance Organization (HMO), Medicare Preferred Provider Organization (PPO) Plan, Medicare Private Fee-For-Service (PFFS) Plan, Medicare Special Needs Plan (SNP), Medicare Medical Savings Account (MSA) Plan, or Medicare Cost Plan</p>
                </div>
                <!--<div class="col-16">
                    <p>Medicare Health Maintenance Organization (HMO), Medicare Preferred Provider Organization (PPO) Plan, Medicare Private Fee-For-Service (PFFS) Plan, Medicare Special Needs Plan (SNP), Medicare Medical Savings Account (MSA) Plan, Medicare Cost Plan</p>
                </div>-->
                <div class="col-16">
                    <div class="bottom-20 centered-label">
                        <input type="checkbox" id="otherPlan" name="otherPlan" disabled="disabled">
                        <label for="otherPlan">Other Plans</label>
                    </div>
                    <p>Dental/Vision/Hearing Products, Supplemental Health Products, Medicare Supplement (Medigap) Products</p>
                </div>
                <!--<div class="col-16">
                    <p>Dental/Vision/Hearing Products, Supplemental Health Products, Medicare Supplement (Medigap) Products</p>
                </div>-->
                <div class="col-16">
                    <p>Signing this form does NOT obligate you to enroll in a plan, affect your current or future Medicare enrollment status, or automatically enroll you in the plan(s) discussed.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p><strong>Beneficiary or Authorized Representative Signature and Signature Date:</strong></p>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="txtSignature">Signature</label>
                        <input name="txtSignature" type="text" id="txtSignature" disabled="disabled" placeholder="Signature">
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="txtdate">Date</label>
                        <input name="txtdate" type="text" id="txtdate" disabled="disabled" placeholder="Date">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p>If you are the authorized representative, please sign above and print below:</p>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="txtRepName">Representative's Name</label>
                        <input name="txtRepName" type="text" id="txtRepName" disabled="disabled" data-type="alphaChar" placeholder="Representative's Name">
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="txtRelationship">Your Relationship to the Beneficiary</label>
                        <input name="txtRelationship" type="text" id="txtRelationship" disabled="disabled" placeholder="Relationship to the Beneficiary">
                    </div>
                </div>
            </div>

            <fieldset>
                <legend>To be completed by Agent:</legend>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper" [ngClass]="{'input-error': agentNameError || specialCharacterAgentNameError}">
                            <ValidatedTextField [label]="'Agent Name'"
                                                id="agentName"
                                                [maxlength]="150"
                                                (onValueChange)="soaSubmitDetails.AgentName = $event"
                                                [text]="soaSubmitDetails.AgentName">
                            </ValidatedTextField>
                            <div class="field-error-message">{{agentNameError}}</div>
                            <div class="field-error-message">{{specialCharacterAgentNameError}}</div>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper" [ngClass]="{'input-error': agentPhoneError || agentPhoneFormatError}">
                            <MaskedValidatedTextField [label]="'Agent Phone'"
                                                      id="agentPhone"
                                                      [maxlength]="10"
                                                      (onValueChange)="soaSubmitDetails.AgentPhone = $event"
                                                      [text]="soaSubmitDetails.AgentPhone"
                                                      [inputMask]="phoneNumberInputMask">
                            </MaskedValidatedTextField>

                            <div class="field-error-message">{{agentPhoneError}}</div>
                            <div class="field-error-message">{{agentPhoneFormatError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper" [ngClass]="{'input-error': agentAddressError}">
                            <ValidatedTextField [label]="'Agent Address'"
                                                id="agentAddress"
                                                [maxlength]="250"
                                                (onValueChange)="soaSubmitDetails.AgentAddress = $event"
                                                [text]="soaSubmitDetails.AgentAddress">

                            </ValidatedTextField>
                            <div class="field-error-message">{{agentAddressError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper" [ngClass]="{'input-error': beneficiaryNameError || specialCharacterBeneficiaryNameError}">
                            <ValidatedTextField [label]="'Beneficiary Name'"
                                                id="beneficiaryName"
                                                [maxlength]="150"
                                                (onValueChange)="soaSubmitDetails.BeneficiaryName = $event"
                                                [text]="soaSubmitDetails.BeneficiaryName">
                            </ValidatedTextField>
                            <div class="field-error-message">{{beneficiaryNameError}}</div>
                            <div class="field-error-message">{{specialCharacterBeneficiaryNameError}}</div>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper" [ngClass]="{'input-error': beneficiaryPhoneError || beneficiaryPhoneFormatError}">
                            <MaskedValidatedTextField [label]="'Beneficiary Phone'"
                                                      id="beneficiaryPhone"
                                                      [maxlength]="10"
                                                      (onValueChange)="soaSubmitDetails.BeneficiaryPhone = $event"
                                                      [text]="soaSubmitDetails.BeneficiaryPhone"
                                                      [inputMask]="phoneNumberInputMask">
                            </MaskedValidatedTextField>
                            <div class="field-error-message">{{beneficiaryPhoneError}}</div>
                            <div class="field-error-message">{{beneficiaryPhoneFormatError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper" [ngClass]="{'input-error': beneficiaryAddressError}">
                            <ValidatedTextField [label]="'Beneficiary Address'"
                                                id="beneficiaryAddress"
                                                [maxlength]="250"
                                                (onValueChange)="soaSubmitDetails.BeneficiaryAddress = $event"
                                                [text]="soaSubmitDetails.BeneficiaryAddress">
                            </ValidatedTextField>
                            <div class="field-error-message">{{beneficiaryAddressError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper" [ngClass]="{'input-error': beneficiaryMethodOfContactError || specialCharacterBeneficiaryMethodOfContactError}">
                            <ValidatedTextField [label]="'Initial Method of Contact (Indicate here if beneficiary was a walk-in.)'"
                                                id="beneficiaryMethodOfContact"
                                                [maxlength]="100"
                                                (onValueChange)="soaSubmitDetails.ContactMethod = $event"
                                                [text]="soaSubmitDetails.ContactMethod">

                            </ValidatedTextField>
                            <div class="field-error-message">{{beneficiaryMethodOfContactError}}</div>
                            <div class="field-error-message">{{specialCharacterBeneficiaryMethodOfContactError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="input-wrapper" [ngClass]="{'input-error': agentSignatureError || specialCharacterAgentSignatureError}">
                            <ValidatedTextField [label]="'Agent Signature'"
                                                id="agentSignatureName"
                                                [maxlength]="100"
                                                (onValueChange)="soaSubmitDetails.AgentSignatureName = $event"
                                                [text]="soaSubmitDetails.AgentSignatureName">

                            </ValidatedTextField>
                            <div class="field-error-message">{{agentSignatureError}}</div>
                            <div class="field-error-message">{{specialCharacterAgentSignatureError}}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20" [ngClass]="{'input-error': planError}">
                            <label for="txtPlans">Plan(s) the agent represented during this meeting</label>
                            <textarea name="txtPlans" rows="3" cols="20" maxlength="500" id="txtPlans" class="ckValidate textMultiline" placeholder="Plans" [(ngModel)]="soaSubmitDetails.Plan" required="required"></textarea>
                            <div class="field-error-message">{{planError}}</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20" [ngClass]="{'input-error': dateOfAppointmentError}">
                            <label for="dateAppointment">Date of Appointment</label>
                            <JQDatePicker [selectedDate]="soaSubmitDetails.ApplicationDate" (elementClicked)="soaSubmitDetails.ApplicationDate = $event"></JQDatePicker>
                            <div class="field-error-message">{{dateOfAppointmentError}} </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-16">
                        <div class="bottom-20" [ngClass]="{'input-error': txtWhyNoDocsError}">
                            <label for="whyNoDocs">Provide explanation why SOA was not documented prior to meeting (if applicable)</label>
                            <textarea name="txtWhyNoDocs"
                                      rows="3" cols="20"
                                      id="txtWhyNoDocs"
                                      placeholder="Why SOA was not documented prior to meeting"
                                      class="textMultiline"
                                      [(ngModel)]="soaSubmitDetails.Instructions"></textarea>
                            <div class="field-error-message">  {{txtWhyNoDocsError}} </div>
                        </div>
                    </div>
                </div>
            </fieldset>
            <div class="row">
                <div class="col-16">
                    <!--<p>ATENCIÓN: Si usted habla español u otros idiomas, tenemos servicios de asistencia lingüística disponibles para usted sin costo alguno. Llame al 1-866-235-5660 (TTY: 711)</p>-->
                    <p>{{insuranceCompanyShortName}} is a Prescription Drug Plan with a Medicare contract offered by {{insuranceCompany}}. Enrollment in {{insuranceCompanyShortName}} depends on contract renewal.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <h1>Helpful Terms</h1>
                </div>
                <div class="col-16">
                    <p> <strong> <u>Stand-alone Medicare Prescription Drug Plans (Part D) </u> </strong></p>
                </div>
                <div class="col-16">
                    <p> A stand-alone drug plan that adds prescription drug coverage to Original Medicare, some Medicare Cost Plans, some Medicare Private-Fee-for-Service Plans, and Medicare Medical Savings Account Plans.</p>
                </div>
                <div class="col-16">
                    <p><strong> <u>Medicare Advantage Plans (Part C) and Cost Plans </u></strong></p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Health Maintenance Organization (HMO) -</strong> A Medicare Advantage Plan that provides all Original Medicare Part A and Part B health coverage and sometimes covers Part D prescription drug coverage. In most HMOs, you can only get your care from doctors or hospitals in the plan's network (except in emergencies).</p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Preferred Provider Organization (PPO) Plan -</strong> A Medicare Advantage Plan that provides all Original Medicare Part A and Part B health coverage and sometimes covers Part D prescription drug coverage. PPOs have network doctors and hospitals but you can also use outof- network providers, usually at a higher cost.</p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Private Fee-For-Service (PFFS) Plan -</strong> A Medicare Advantage Plan in which you may go to any Medicare-approved doctor, hospital and provider that accepts the plan's payment, terms and conditions and agrees to treat you - not all providers will. If you join a PFFS Plan that has a network, you can see any of the network providers who have agreed to always treat plan members. You will usually pay more to see out-of-network providers.</p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Special Needs Plan (SNP) -</strong> A Medicare Advantage Plan that has a benefit package designed for people with special healthcare needs. Examples of the specific groups served include people who have both Medicare and Medicaid, people who reside in nursing homes, and people who have certain chronic medical conditions.</p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Medical Savings Account (MSA) Plan -</strong> MSA Plans combine a high deductible health plan with a bank account. The plan deposits money from Medicare into the account. You can use it to pay your medical expenses until your deductible is met.</p>
                </div>
                <div class="col-16">
                    <p><strong>Medicare Cost Plan -</strong> In a Medicare Cost Plan, you can go to providers both in and out of network. If you get services outside of the plan's network, your Medicare-covered services will be paid for under Original Medicare but you will be responsible for Medicare coinsurance and deductibles.</p>
                </div>
                <div class="col-16">
                    <p><strong>Med Supp -</strong> Plans offering a supplemental policy to fill "gaps" in Original Medicare coverage. A Medigap policy typically pays some or all of the deductible and coinsurance amounts applicable to Medicare-covered services, and sometimes covers items and services that are not covered by Medicare, such as care outside of the country. These plans are not affiliated or connected to Medicare.</p>
                </div>
                <div class="col-16">
                    <p><strong>Supplemental Health Products -</strong> Plans offering additional benefits; payable to consumers based upon their medical utilization; sometimes used to defray copays/coinsurance. These plans are not affiliated or connected to Medicare</p>
                </div>
                <div class="col-16">
                    <p><strong>Dental/Vision/Hearing Products -</strong> Plans offering additional benefits for consumers who are looking to cover needs for dental, vision or hearing. These plans are not affiliated or connected to Medicare.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <h2 class="partition">Agent Instructions</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p>If you are doing a sales presentation to a beneficiary, you MUST have a documented scope of what you will be discussing with the beneficiary prior to the appointment. A beneficiary cannot agree to the scope over the phone and sign the documentation later. Documentation must be in writing in the form of a signed document by the beneficiary. If you are sending an enrollment form for a client to {{insuranceCompany}}, you must also send this document, signed by the client, to {{insuranceCompanyShortName}} as well. </p>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p class="partition">Please note, the person who will discuss the products is either employed or contracted by a Medicare plan. They do not work directly for the federal government. This individual may also be paid based on your enrollment in a plan.</p>
                </div>
            </div>
        </div>
    </ng-template>
    <div class="row">
        <div class="col-16">
            <div class="input-wrapper" [ngClass]="{'input-error': beneficiaryEmailError || specialCharacterbeneficiaryEmailError}">
                <ValidatedTextField [label]="'Please provide the email address of the prospective beneficiary.'"
                                    id="beneficiaryEmailAddresss"
                                    [maxlength]="60"
                                    (onValueChange)="soaSubmitDetails.BeneficiaryEmail = $event"
                                    [text]="soaSubmitDetails.BeneficiaryEmail">
                </ValidatedTextField>
                <div class="field-error-message">{{beneficiaryEmailError}}</div>
                <div class="field-error-message">{{specialCharacterbeneficiaryEmailError}}</div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-16">
            <p>
                <ErrorMessages [errorMessages]="errorMessages"></ErrorMessages>
            </p>
        </div>
    </div>


    <div class="row">
        <div class="col-16">
            <button id="sendEmail" class="button primary" (click)="sendEmail()">Send Email</button>
        </div>
    </div>

    <!--<ValidatedTextField
                                [label]="'Date of Appointment:'"
                                id="dateAppointment"
                              (onValueChange)="soaSubmitDetails.ApplicationDate = $event">
                    </ValidatedTextField>

                     <label for="dateAppointment">Date of Appointment:</label>
                     <input type="date" id="dateAppointment" [(ngModel)]="soaSubmitDetails.ApplicationDate" placeholder="Application Date" required="true"/>-->
</div>


